var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRedo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 13.6731C3.00213 11.8484 3.72795 10.099 5.01824 8.80876C6.30852 7.5185 8.05791 6.79273 9.88263 6.79065H16.1919L14.7965 5.39498C14.5348 5.13099 14.3884 4.77411 14.3892 4.40243C14.3901 4.03076 14.5381 3.67454 14.8009 3.41171C15.0637 3.14888 15.4199 3.00085 15.7916 3C16.1633 2.99915 16.5201 3.14555 16.7841 3.40718L20.5791 7.2021C20.8427 7.4657 20.9907 7.82322 20.9907 8.196C20.9907 8.56878 20.8427 8.9263 20.5791 9.1899L16.7841 12.9848C16.5201 13.2464 16.1633 13.3928 15.7916 13.392C15.4199 13.3911 15.0637 13.2431 14.8009 12.9803C14.5381 12.7175 14.3901 12.3612 14.3892 11.9896C14.3884 11.6179 14.5348 11.261 14.7965 10.997L16.1919 9.60165H9.88263C8.80281 9.60165 7.76723 10.0306 7.00368 10.7942C6.24014 11.5577 5.81119 12.5933 5.81119 13.6731C5.81119 14.7529 6.24014 15.7885 7.00368 16.552C7.76723 17.3156 8.80281 17.7445 9.88263 17.7445H19.5853C20.5851 18.1529 19.9544 17.7788 20.126 17.8489C20.2975 17.919 20.4536 18.0223 20.5851 18.1529C20.7166 18.2836 20.8209 18.4389 20.8921 18.6101C20.9633 18.7812 21 18.9647 21 19.1501C21 19.3354 20.9633 19.5189 20.8921 19.6901C20.8209 19.8612 20.7166 20.0166 20.5851 20.1472C20.4536 20.2778 20.2975 20.3812 20.126 20.4513C19.9544 20.5214 19.7706 20.5568 19.5853 20.5556H9.88263C8.0579 20.5535 6.3085 19.8277 5.01821 18.5375C3.72792 17.2472 3.00211 15.4978 3 13.6731Z",
    fill: "#696969"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedo);
export default __webpack_public_path__ + "static/media/redo.d9993276cda8cac5de18d2013c16e990.svg";
export { ForwardRef as ReactComponent };